import o from"../platform/index.js";var r,t,a=o.hasStandardBrowserEnv?(r=new URL(o.origin),t=o.navigator&&/(msie|trident)/i.test(o.navigator.userAgent),a=>(a=new URL(a,o.origin),r.protocol===a.protocol&&r.host===a.host&&(t||r.port===a.port))):()=>!0;export{a as default};
//# sourceMappingURL=isURLSameOrigin.js.map
